import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Categorymaster} from "../models/categorymaster";
import {CategoryService} from "../services/category.service";
import {ActivatedRoute, Router} from "@angular/router";
declare var $: any;

@Component({
    selector: 'app-addcategory',
    templateUrl: './addcategory.component.html'
})
export class AddcategoryComponent implements OnInit {
    title:string = "Add category";
    category_id = 0;
    categoryform: FormGroup;
    categoryinfo: Categorymaster;
    isEdit: boolean = false;
    ckeditorContent;
    constructor(
        private categoryService:CategoryService,
        private router: Router,
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
    ) {
        activatedRoute.params.subscribe(params => {
            this.category_id = params["id"];
        });
        if(this.category_id > 0){
            this.isEdit = true;
        }
        if(this.category_id > 0){
            this.title = "Edit category";
        }
    }

    ngOnInit() {
        this.title;
        this.isEdit;
        this.categoryform = this.fb.group({
            name: ['',
                Validators.required
            ],
            is_locked: ['',
                Validators.required
            ],
            image: ['',
                Validators.required
            ],
        });

        if (this.isEdit) {
            this.getCategoryInfo();
        }
        //this.loadScriptLibrary();
    }

    onSubmit(categoryValue) {
        if(this.isEdit){
            this.updateForm(categoryValue);
        }else{
            this.addForm(categoryValue);
        }
    }

    addForm(categoryValue){
        $('#save_category').button('loading');
        this.categoryService.createCategory(categoryValue).then(CategoryData => {
            if(CategoryData['code'] === 200){
                $('#save_category').button('reset');
                $.toast({heading: 'Success', text: CategoryData['message'], position: 'top-right', showHideTransition: 'slide', icon: 'success'});
                this.router.navigate(['/categories']);
            }else{
                $.toast({heading: 'Warning', text: CategoryData['message'], position: 'top-right', showHideTransition: 'slide', icon: 'warning'});
                $('#save_category').button('reset');
            }
        }).catch(err => {
            if(err['code'] != 200){
                $.toast({heading: 'Error', text: err['message'], position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }else{
                $.toast({heading: 'Error', text: 'Server error! Please try again later', position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }
            $('#save_category').button('reset');
        });
    }

    updateForm(categoryValue){
        $('#update_category').button('loading');
        categoryValue['category_id'] = this.category_id;
        this.categoryService.updateCategory(categoryValue).then(CategoryData => {
            if(CategoryData['code'] === 200){
                $('#update_category').button('reset');
                $.toast({heading: 'Success', text: CategoryData['message'], position: 'top-right', showHideTransition: 'slide', icon: 'success'});
                this.router.navigate(['/categories']);
            }else{
                console.log(CategoryData['message']);
                $.toast({heading: 'Warning', text: CategoryData['message'], position: 'top-right', showHideTransition: 'slide', icon: 'warning'});
                $('#update_category').button('reset');
            }
        }).catch(err => {
            if(err['status'] != 200){
                $.toast({heading: 'Error', text: err['message'], position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }else{
                $.toast({heading: 'Error', text: 'Server error! Please try again later', position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }
            $('#update_category').button('reset');
        });
    }

    getCategoryInfo=function () {
        this.categoryService.getCategoryInfo(this.category_id).then(data => {
            console.log("CategoryInfo=======>",data['data']);
            this.categoryinfo = data['data'];
            this.patchForm();
        });
    }

    patchForm() {
        console.log("CategoryInfoDetails=======>"+this.categoryinfo.name)
        this.categoryform.patchValue({
           name: this.categoryinfo.name,
           image: this.categoryinfo.image,
           is_locked: this.categoryinfo.is_locked,

            // vSlug: this.categoryinfo.vSlug,
            // tDescription:this.categoryinfo.Description,
        })
    }

    public loadScriptLibrary() {
        let body = <HTMLDivElement> document.body;
        let script = document.createElement('script');
        script.innerHTML = '';
        script.src = 'assets/adminlte/plugins/ckeditor/ckeditor.js';
        body.appendChild(script);

        let body2 = <HTMLDivElement> document.body;
        let script2 = document.createElement('script');
        script2.innerHTML = 'CKEDITOR.replace( \'tDescription\' );';
        body2.appendChild(script2);
    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/categoriesmaster/addcategory/addcategory.component.ts